export default __webpack_public_path__ + "static/media/hint.c66e3a50.svg";